// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__zbvsM","shake":"FloatingButton_shake__jKVhO"};